import { alpha, useTheme } from '@mui/material';
export const useHelpCenterStyles = () => {
    const theme = useTheme();
    return {
        paper: (isMobile) => ({
            width: isMobile ? '100%' : 500,
            maxWidth: '100vw',
            backgroundColor: `${theme.palette.common.white} !important`,
            backdropFilter: 'none !important',
            WebkitBackdropFilter: 'none !important',
            display: 'flex',
            flexDirection: 'column'
        }),
        header: {
            backgroundColor: theme.palette.background.paper,
            px: 3,
            py: 3,
            flexShrink: 0
        },
        headerRow: {
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            width: '100%'
        },
        iconChip: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: theme.spacing(6),
            height: theme.spacing(6),
            borderRadius: theme.spacing(2),
            backgroundColor: alpha(theme.palette.primary.main, 0.08)
        },
        iconChipInner: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: theme.spacing(4),
            height: theme.spacing(4),
            color: theme.palette.primary.main,
            '& svg': { width: '100%', height: '100%' }
        },
        titleBlock: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column'
        },
        closeButton: {
            flexShrink: 0,
            color: theme.palette.text.primary
        },
        body: {
            flex: 1,
            overflowY: 'auto',
            px: 3,
            pb: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 3
        },
        section: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        itemList: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5
        },
        itemRow: {
            display: 'flex',
            gap: 1.5,
            alignItems: 'flex-start'
        },
        itemTextBlock: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0
        },
        stepList: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5
        },
        stepRow: {
            display: 'flex',
            gap: 1.5,
            alignItems: 'center'
        },
        stepBadge: {
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: theme.spacing(3),
            height: theme.spacing(3),
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main
        },
        stepText: {
            flex: 1
        },
        hintBox: {
            display: 'flex',
            gap: 1,
            p: 1,
            borderRadius: '14px',
            backgroundColor: alpha(theme.palette.primary.main, 0.08)
        },
        hintTextBlock: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0
        }
    };
};
